import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        }
    }
);

const courses = {
    'USD': 1,
    'KZT': 525,
    'RUB': 90,
    'TRY': 40
};
const currencies = {
    'en': 'USD',
    'kz': 'KZT',
    'ru': 'RUB',
    'tr': 'TRY'
};

export const i18nCurrency = (value, format = true) => {
    const currencyCourse = courses[currencies[i18n.language]];

    if (!currencyCourse) {
        return value;
    }

    const newValue = Math.round(value * currencyCourse);

    if (!format) {
        return newValue - newValue % 100;
    }

    return (newValue - newValue % 100).toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
};

export default i18n;